import {
  Box,
  Checkbox,
  CheckboxGroup,
  Flex,
  FormControl,
  FormErrorMessage,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Field } from "formik";

export const ProgramaApadrinhamentoAba = ({ children, props }) => {
  return (
    <>
      <Flex mb={4} justifyContent={"space-between"}>
        <Text
          fontWeight={700}
          fontSize="16px"
          lineHeight="21.6px"
          color={"#575553"}
        >
          Programa de Apadrinhamento
        </Text>
        {children}
      </Flex>

      <Box mt={7}>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"O Serviço de Acolhimento possui voluntariado?"}
          mb={4}
        >
          O Serviço de Acolhimento mantém Programa de Apadrinhamento?
        </Text>

        <Field name="mantemPrograma">
          {({ field, form }) => (
            <FormControl
              isInvalid={
                form.errors.mantemPrograma && form.touched.mantemPrograma
              }
              id="possuiAcessoMCA"
              width="max-content"
            >
              <CheckboxGroup
                value={field.value || []}
                onChange={(value) =>
                  props.setFieldValue("mantemPrograma", value)
                }
              >
                <Stack flexDirection="row" alignItems={"end"} gap={4}>
                  <Checkbox value="S">Sim</Checkbox>

                  <Checkbox value="N">Não</Checkbox>
                </Stack>

                <FormErrorMessage mr="-14">
                  {form.errors.mantemPrograma}
                </FormErrorMessage>
              </CheckboxGroup>
            </FormControl>
          )}
        </Field>
      </Box>
      <Box mt={7}>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"O Serviço de Acolhimento possui voluntariado?"}
          mb={4}
        >
          Em caso Positivo, esse Programa se encontra Inscrito no CMDCA?
        </Text>

        <Field name="encontraInscritoCMDCA">
          {({ field, form }) => (
            <FormControl
              isInvalid={
                form.errors.encontraInscritoCMDCA &&
                form.touched.encontraInscritoCMDCA
              }
              id="possuiAcessoMCA"
              width="max-content"
            >
              <CheckboxGroup
                value={field.value || []}
                onChange={(value) =>
                  props.setFieldValue("encontraInscritoCMDCA", value)
                }
                isDisabled={!props.values.mantemPrograma.includes("S")}
              >
                <Stack flexDirection="row" alignItems={"end"} gap={4}>
                  <Checkbox value="S">Sim</Checkbox>

                  <Checkbox value="N">Não</Checkbox>
                </Stack>

                <FormErrorMessage mr="-14">
                  {form.errors.encontraInscritoCMDCA}
                </FormErrorMessage>
              </CheckboxGroup>
            </FormControl>
          )}
        </Field>
      </Box>
    </>
  );
};
